// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file webauthn_prf_support_status.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file webauthn_prf_support_status.proto.
 */
export const file_webauthn_prf_support_status: GenFile = /*@__PURE__*/
  fileDesc("CiF3ZWJhdXRobl9wcmZfc3VwcG9ydF9zdGF0dXMucHJvdG8SBmRvbWFpbiqbAQoYV2ViYXV0aG5QcmZTdXBwb3J0U3RhdHVzEicKI1dFQkFVVEhOX1BSRl9TVVBQT1JUX1NUQVRVU19VTktOT1dOEAASKwonV0VCQVVUSE5fUFJGX1NVUFBPUlRfU1RBVFVTX1VOQVZBSUxBQkxFEAESKQolV0VCQVVUSE5fUFJGX1NVUFBPUlRfU1RBVFVTX0FWQUlMQUJMRRACQjBaLmdpdGxhYi5jb20vY290ZWNoZGUvbW9ub3JlcG8vYmFja2VuZC9kb21haW4vcGJiBnByb3RvMw");

/**
 * @generated from enum domain.WebauthnPrfSupportStatus
 */
export enum WebauthnPrfSupportStatus {
  /**
   * PRF availability is unknown
   *
   * @generated from enum value: WEBAUTHN_PRF_SUPPORT_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * PRF is known to be unavailable
   *
   * @generated from enum value: WEBAUTHN_PRF_SUPPORT_STATUS_UNAVAILABLE = 1;
   */
  UNAVAILABLE = 1,

  /**
   * PRF is known to be available
   *
   * @generated from enum value: WEBAUTHN_PRF_SUPPORT_STATUS_AVAILABLE = 2;
   */
  AVAILABLE = 2,
}

/**
 * Describes the enum domain.WebauthnPrfSupportStatus.
 */
export const WebauthnPrfSupportStatusSchema: GenEnum<WebauthnPrfSupportStatus> = /*@__PURE__*/
  enumDesc(file_webauthn_prf_support_status, 0);

